import React from "react";
import colors from "../utils/colors";
import { VERSION } from "../config";
import { useControlContext } from "../context";

function Footer() {
  const { backEndVersion } = useControlContext();

  return (
    <footer
      className="pt-4 pb-1 text-muted text-center text-small"
      style={styles.footer}
    >
      <p style={styles.paragraph}>
        <span style={styles.link}>
          <a
            className="ms-2 mb-2"
            href="https://sharmaq.com.br/"
            target="_blank"
            rel="noreferrer"
            style={styles.sharmaqLink}
          >
            <span className="me-1">&copy; {new Date().getFullYear()}</span>
            SHARMAQ Sistemas
          </a>
        </span>
        <span style={styles.version}>
          {VERSION}
          {backEndVersion !== "0.0.0" && ` - ${backEndVersion}`}
        </span>
      </p>
    </footer>
  );
}

const styles = {
  footer: {
    backgroundColor: colors.darkblue,
    color: colors.light,
    padding: "20px",
    textAlign: "center",
  },
  sharmaqLink: {
    color: colors.lightBeige,
    textDecoration: "none",
  },
  paragraph: {
    lineHeight: "0.8",
    color: colors.light,
  },
  link: {
    display: "block",
    color:  colors.light,
  },
  version: {
    fontSize: "0.7em",
  },
};

export default Footer;
